import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrVerificationDocumentHint.ts
var t = () => e("verificationDocumentHint");
//#endregion
export { t as useTrVerificationDocumentHint };
